const DISCRETE_UOMS = new Set(['unit', 'units', 'pack', 'dozen']);

export const isDiscreteUom = (uom) => (
  DISCRETE_UOMS.has(String(uom || 'units').trim().toLowerCase())
);

export const normalizeCartQuantity = (product, rawQuantity, maximum = Number.POSITIVE_INFINITY) => {
  const isMissing = rawQuantity === null
    || rawQuantity === undefined
    || rawQuantity === ''
    || typeof rawQuantity === 'boolean';
  const quantity = isMissing ? Number.NaN : Number(rawQuantity);
  const uom = product?.uom || product?.sellingUom || product?.b2cUnit?.sellingUom;

  if (
    !Number.isFinite(quantity)
    || quantity <= 0
    || (isDiscreteUom(uom) && !Number.isInteger(quantity))
  ) {
    return null;
  }

  return Math.min(maximum, quantity);
};
